import { render, staticRenderFns } from "./SimpleLoginPhone.vue?vue&type=template&id=04bf680c&scoped=true&"
import script from "./SimpleLoginPhone.vue?vue&type=script&lang=js&"
export * from "./SimpleLoginPhone.vue?vue&type=script&lang=js&"
import style0 from "./SimpleLoginPhone.vue?vue&type=style&index=0&id=04bf680c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bf680c",
  null
  
)

export default component.exports